import React from "react"

const SHOWN_STATUSES = new Set([ "running", "paused", "completed", "archived" ])

function statusPillStyle(status) {
  switch (status) {
    case "completed":
      return { bg: "#D1FAE5", fg: "#047857" }
    case "running":
      return { bg: "#F1F5F9", fg: "#475569" }
    case "paused":
      return { bg: "#F8FAFC", fg: "#475569" }
    default: // archived
      return { bg: "#F8FAFC", fg: "#64748B" }
  }
}

function formatDate(iso) {
  if (!iso) return ""
  const d = new Date(iso)
  const months = [ "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC" ]
  return `${months[d.getMonth()]} ${String(d.getDate()).padStart(2, "0")}`
}

function conversionRate(experiment) {
  const { impressions_count, conversions_count } = experiment
  if (!impressions_count) return null
  return (conversions_count / impressions_count) * 100
}

function ExperimentRow({ t, experiment }) {
  const pill = statusPillStyle(experiment.status)
  const rate = conversionRate(experiment)
  const statusKey = `experiment_status_${experiment.status}`
  const dateIso = experiment.completed_at || experiment.started_at || experiment.created_at

  return (
    <li
      className="grid gap-5 py-4 border-b border-rule last:border-b-0 items-center"
      style={{ gridTemplateColumns: "100px minmax(0,1fr) 90px 60px" }}
    >
      <span
        className="inline-flex items-center gap-2 text-[11px] font-medium font-mono rounded-pill"
        style={{ background: pill.bg, color: pill.fg, padding: "3px 10px" }}
      >
        <span className="w-[6px] h-[6px] rounded-full" style={{ background: pill.fg, opacity: 0.55 }} />
        {t(`dashboard.overview.${statusKey}`)}
      </span>

      <div className="min-w-0">
        <div className="text-sm text-ink-primary truncate">{experiment.name}</div>
        <div
          className="font-mono text-[11px] text-ink-faint truncate"
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          {experiment.target_selector} · {experiment.page_path}
        </div>
      </div>

      <span
        className="text-[15px] font-medium text-ink-primary text-right"
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        {rate == null ? "—" : `${rate.toFixed(1)}%`}
      </span>
      <span
        className="font-mono text-[11px] text-ink-tertiary text-right"
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        {formatDate(dateIso)}
      </span>
    </li>
  )
}

export default function ExperimentsList({ t, experiments }) {
  const rows = experiments.filter((e) => SHOWN_STATUSES.has(e.status))

  return (
    <section>
      <p
        className="font-mono text-[10px] text-ink-tertiary mb-3"
        style={{ letterSpacing: "0.15em", fontVariantNumeric: "tabular-nums" }}
      >
        {t("dashboard.overview.eyebrow_experiments")}
      </p>

      {rows.length === 0 ? (
        <p className="text-sm text-ink-tertiary py-4 border-t" style={{ borderTopWidth: 1, borderTopColor: "#0F172A" }}>
          {t("dashboard.overview.experiments_empty")}
        </p>
      ) : (
        <ul className="border-t" style={{ borderTopWidth: 1, borderTopColor: "#0F172A" }}>
          {rows.map((e) => <ExperimentRow key={e.id} t={t} experiment={e} />)}
        </ul>
      )}
    </section>
  )
}
